import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { LocationService } from "../../../services/location.service";
import { Countries } from "../../../models/countries";
import { Inventory } from "../../../models/inventory";
import { Methods } from "../../../shared/methods";

import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

declare const $: any;

@Component({
  selector: "app-crud-inventory",
  templateUrl: "./crud-inventory.component.html",
  styleUrls: ["./crud-inventory.component.css"],
})
export class CrudInventoryComponent implements OnInit {
  public loading = false;
  public saving = false;
  public mtds: Methods = new Methods();
  public inventory: Inventory = new Inventory();
  public containerName;

  public countries: Array<any> = [];
  public userLocations: Array<any> = [];
  public conditions: Array<any> = [];
  public identity;
  public token;

  public id;

  public Editor = ClassicEditor;

  constructor(
    private _locationService: LocationService,
    private _service: PrincipalinventoryService,
    private _router: Router,
    public dialogRef: MatDialogRef<CrudInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.id = this.data.id;
    console.log("crud data => ", this.data);
    console.log("crud inventory id => ", this.id);
    this.identity = JSON.parse(localStorage.getItem("identity"));
    console.log(this.identity);
    this.token = JSON.parse(localStorage.getItem("token"));

    let countries: Countries = new Countries();
    this.countries = countries.countries;
  }

  ngOnInit() {
    this.loading = true;
    this.getLocations();
    this.getInventory();
    this.getConditions();
    this.getContainers();
  }

  getInventory() {
    this._service.showOne(this.id, this.data.type).subscribe(
      (r) => {
        console.log(r);
        // console.log(r.data.master.inventoryCategory.name);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.inventory = new Inventory(
            r.data.item,
            r.data.mfgr,
            r.data.warehouseTable ? r.data.warehouseTable.id : null,
            r.data.countryOrigin,
            r.data.serialnumber,
            r.data.unitcost,
            r.data.condition !== null ? r.data.condition.id : null,
            r.data.customerAsset,
            r.data.description,
            r.data.status,
            r.data.extendeddescription,
            r.data.internalComments,
            r.data.commentstovendor,
            r.data.pp || null,
            r.data.po || null,
            r.data.sp || null,
            r.data.so || null,

            r.data.inventoryid,
            [],
            null,
            null,
            '',
            null,
            null,
            null,
            r.data.weightItem ? r.data.weightItem.id : '',
            null,
            (r.data.master && r.data.master.inventoryCategory) ? r.data.master.inventoryCategory.name :  '',
            r.data.testingStatus,
            r.data.poline,
            r.data.soLine,
            r.data.warehouseTable ? r.data.warehouseTable.name : '',
          );

          console.log(this.inventory);
          if (r.data.weightItem && r.data.weightItem.enableAsAVirtualContainer !== 1) {
            this.containerName = `${r.data.weightItem.id} - ${r.data.weightItem.item} - ${
              r.data.weightItem.internalLocation !== null ? r.data.weightItem.internalLocation.locationName  + ': ' + r.data.weightItem.internalLocation.locationRow + ' - ' +
              r.data.weightItem.internalLocation.locationBay + ' - ' + r.data.weightItem.internalLocation.locationLevel + ' - ' + r.data.weightItem.internalLocation.locationSection : ''
            }`;
          } else {
            this.containerName = r.data.weightItem ?
            `${r.data.weightItem.id} - ${r.data.weightItem.nameVirtualContainer}` : '';
          }
          this.getLogs();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  public aguante2 = false;

  ChangeWarehouse() {
    $("#changeWarehouse").modal("show");
    this.aguante2 = true;
    setTimeout(
      function () {
        this.aguante2 = false;
      }.bind(this),
      250
    );
  }

  closeChangeWarehouse() {
    $("#changeWarehouse").modal("hide");
  }

  changeWH(e) {
    console.log(e);
    this.inventory.warehouse_id = e.id;
    this.inventory.warehouse_name = e.name;
    this.closeChangeWarehouse();
  }

  public loadingContainers = false;
  public containers = [];

  getContainers() {
    this.loadingContainers = true;
    this._locationService.getContainersInput(this.token).subscribe(
      (r) => {
        console.log(r);
        this.loadingContainers = false;
        this.containers = r.data.map( element => {
          return {
            id: element.id,
            name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation : ''
            }`
            /*name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation.locationName  + ': ' + element.internalLocation.locationRow + ' - ' +
              element.internalLocation.locationBay + ' - ' + element.internalLocation.locationLevel + ' - ' + element.internalLocation.locationSection : ''
            }`*/
          }
        })

        if ( this.containers.findIndex(e => e.id === this.inventory.container_id) === -1) {
          this.containers.push(
            {id: this.inventory.container_id, name: this.containerName }
          )
        }
      }, error => {
        this.loadingContainers = false;
      }
    );
  }

  saveContainer(e) {
    console.log(e);
    this.inventory.container_id = e.id;
    const json = {field:"weightitem", value: this.inventory.container_id}

    this._locationService.saveContainers(this.token, this.id, json).subscribe(
      r => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess('Container inventory has been updated successfully');
        } else {
          this.mtds.notifyError(r.msg);
        }
      }
    );
  }

  public wharehouseList: Array<any> = [];
  public buscandoWharehouse = true;

  getLocations() {
    this._locationService
      .getLocationsByUser(this.token, this.identity.sub)
      .subscribe((response) => {
        this.userLocations = response.data;
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.wharehouseList = response.data;
        } else {
          this.mtds.notifyError('ERROR!', response.msg);
        }
        this.buscandoWharehouse = false;
      });
  }

  getConditions() {
    this._locationService.getConditions(this.token).subscribe((response) => {
      this.conditions = response.data;
    });
  }

  getLogs() {
    this._service.getLogs(this.id, '').subscribe(
      r => {
        console.log(r);
      }
    );
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.saving = true;
    this._service.edit(this.id, this.inventory).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.mtds.notifySuccess("Changes have been saved successfully");
          this.dialogRef.close(true);
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  gotopp(id) {
    window.open('/purchaseproposal/' + id);
  }

  gotopo(id) {
    window.open('/purchase-order/' + id);
  }

  gotosp(id) {
    window.open('/salesproposal/' + id);
  }

  gotoso(id) {
    window.open('/sales-orders/' + id);
  }
}
